import { Text } from 'src/onboarding/components/typography/Text/Text';
import styles from './style.module.scss';
import { Caption } from 'src/onboarding/components/typography/Caption/Caption';
import { getBmiCategory } from 'src/onboarding/helpers/getBmiCategory';
import { t } from '@web-solutions/module-localization';
import { useEffect, useState } from 'react';

const HealthDashboardCard = ({ url, bmi }) => {
  const minBMI = 10;
  const maxBMI = 45;
  const category = getBmiCategory(bmi);

  const categoryLabel = category ? t(`onboarding.personalSummary.${category.toLowerCase()}`) : '';
  const clampedBMI = Math.max(minBMI, Math.min(bmi, maxBMI));

  const markerLeft = ((clampedBMI - minBMI) / (maxBMI - minBMI)) * 100;
  const [urlImage, setUrlImage] = useState('');
  const convertFileToBase64 = (file: File | Blob) => {
    const reader = new FileReader();
    reader.onloadend = () => {
      setUrlImage(reader.result as string);
    };
    reader.readAsDataURL(file);
  };

  useEffect(() => {
    if (url instanceof File || url instanceof Blob) {
      convertFileToBase64(url);
    } else if (typeof url === 'string') {
      setUrlImage(url);
    }
  }, [url]);
  
  return (
    <div className={styles.healthCard}>
      <img src={urlImage} alt='User body scan' className={styles.bodyScan} />
      <div className={styles.metricsContainer}>
        <Text size='m' bold>
          {t('onboarding.personalPlan.healthDashboardCard.title')}
        </Text>
        <div className={styles.metrics}>
          <div className={styles.metricItem}>
            <Caption size='s' className={styles.metricTitle}>
              {t('onboarding.personalPlan.healthDashboardCard.bmi')}
            </Caption>
            <Text size='s' semibold>
              {bmi} ({categoryLabel})
            </Text>
            <div className={styles.bmiScale}>
              <div className={styles.marker} style={{ left: `${markerLeft}%` }} />
            </div>
          </div>
          <div className={styles.metricItem}>
            <Caption size='s' className={styles.metricTitle}>
              {t('onboarding.personalPlan.healthDashboardCard.bfp')}
            </Caption>
            <Text size='s' semibold className={styles.metricValue}>
              24.5%
            </Text>
          </div>
          <div className={styles.metricItem}>
            <Caption size='s' className={styles.metricTitle}>
              {t('onboarding.personalPlan.healthDashboardCard.whr')}
            </Caption>
            <Text size='s' semibold className={styles.metricValue}>
              0.71
            </Text>
          </div>
          <div className={styles.metricItem}>
            <Caption size='s' className={styles.metricTitle}>
              {t('onboarding.personalPlan.healthDashboardCard.bodyType')}
            </Caption>
            <Text size='s' semibold className={styles.metricValue}>
              {t('onboarding.personalPlan.healthDashboardCard.hourglass')}
            </Text>
          </div>
          <div className={styles.metricItem}>
            <Caption size='s' className={styles.metricTitle}>
              {t('onboarding.personalPlan.healthDashboardCard.data')}
            </Caption>
            <Text size='s' semibold className={styles.metricValue}>
              {t('onboarding.personalPlan.healthDashboardCard.top30')}
            </Text>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HealthDashboardCard;
